export default __webpack_public_path__ + "static/media/deauville09.20543e9c.jpg";